module.exports = __webpack_public_path__ + "static/images/pin-address.2o5heWY.svg";